import PickListModel from './PickListModel';

export default function ordenarPickList(lista: PickListModel[]) {
    return lista.sort((p1: PickListModel, p2: PickListModel) => (p1.descricao < p2.descricao ? -1 : 1));
}
